module.exports = __webpack_public_path__ + "img/qrcode.599aa401.png";